export default __webpack_public_path__ + "static/media/flag-mauritius.918c1f57.svg";